import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Empresa } from "../../../Hooks/UsuarioHook";
import { Button, TextField, Typography } from "@mui/material";
import { GerarForm } from "../../Boleto/GerarForm";
interface Props {
  empresa: Empresa;
}
export function GerarBoleto({ empresa }: Props) {
  const [mes, setMes] = React.useState("");
  const [ano, setAno] = React.useState("");
  const [openGeradorBoleto, setGeradorBoleto] = React.useState(false);
  const handleChange1 = (event: SelectChangeEvent) => {
    setMes(event.target.value as string);
  };

  const handleChange2 = (event: SelectChangeEvent) => {
    setAno(event.target.value as string);
  };

  React.useEffect(() => {
    let mes = new Date().getMonth().toString();
    if (mes == "0") {
      mes = "12";
    }
    setMes(mes);
    if (mes == "12") {
      setAno((new Date().getFullYear() - 1).toString());
    } else {
      setAno(new Date().getFullYear().toString());
    }
  }, []);

  return (
    <>
      <Button variant="contained" onClick={() => setGeradorBoleto(true)} style={{whiteSpace:"nowrap"}}>
        GERAR GUIA ISSQN {mes.padStart(2, "0")}/{ano}
      </Button>

      <GerarForm
        open={openGeradorBoleto}
        onClose={() => setGeradorBoleto(false)}
        periodo={`${mes.padStart(2, "0")}/${ano}`}
      />
    </>
  );
}
